module.exports = __webpack_public_path__ + "static/media/breast_pacli_plot 3.16.23 PM.0ed8eeb8.png";